<script>
import DropDown from '../reUse/DropDown.vue';
import FiltriO from '../reUse/Filtri.vue';
import Notification from "../reUse/Notification.vue";
import { i18n } from '@/i18n'
import { config } from '@/config'
import sl from '@/Prevodi/ObracunJadralnih-sl.json';
import en from '@/Prevodi/ObracunJadralnih-en.json';
import it from '@/Prevodi/ObracunJadralnih-it.json';
export default {
  components: {
    DropDown,
    FiltriO,
    Notification
  },
  props: {},
  data() {
    return {
      prevodi: false,
      datumO: new Date().toISOString().split('T')[0],
      datumD: new Date().toISOString().split('T')[0],
      pilotName: '',
      regLetala: '',
      klub: '',
      klubPJ: '',
      klubPM: '',
      klubJ: '',
      klubM: '',
      dPilot: false,
      dLetalo: false,
      dFiltri: false,
      dKlubi: false,
      dKlubiPJ: false,
      dKlubiPM: false,
      dKlubiJ: false,
      dKlubiM: false,
      Letala: [],
      Piloti: [],
      Klubi: [],
      KlubiL: [],
      PodatkiObracun: [],
      izbranZapis: [],
      AllFlightsTime: '00:00',
      izracun: [],
      sortAscending: true,
      polja: ['REG', 'VZLET', 'PILOT', 'TRAJANJE', 'NALOGA'], //default prikazna polja
      odpriPolja: false,
      //NOTIFICATION
      ShowNoti: false,
      podatkiIzbris: {},
      text: '',
      types: '',
      pot: config.baseUrl,
      sending: false,
      exporting: false,
      printing: false,
    }
  },
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  mounted() {
    this.GetLetala();
    this.GetPiloti();
    this.GetKlubi();
    this.GetPodatkiObracuna();
  },
  computed: {
    FiltriraniPodatki() {
      if (this.klubPJ !== '') {
        if (this.klubPM !== '') {
          if (this.klubJ !== '') {
            if (this.klubM !== '') {
              if (this.pilotName !== '') {
                if (this.regLetala !== '') { //če so vsi filtri "aktivni"
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.klub_pilot_vleke === this.klubPM && podatki.klub_letala === this.klubJ && podatki.klub_letala_vleke === this.klubM && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else { //vsi aktivni razen filter registracije
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.klub_pilot_vleke === this.klubPM && podatki.klub_letala === this.klubJ && podatki.klub_letala_vleke === this.klubM && podatki.pilot === this.pilotName);
                }
              } else { //če filter pilota ni aktiven
                if (this.regLetala !== '') { //če je aktiven filter registracije letala
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.klub_pilot_vleke === this.klubPM && podatki.klub_letala === this.klubJ && podatki.klub_letala_vleke === this.klubM && podatki.registracija === this.regLetala);
                } else {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.klub_pilot_vleke === this.klubPM && podatki.klub_letala === this.klubJ && podatki.klub_letala_vleke === this.klubM);
                }
              }
            } else {//če filter kluba vlečnega letala ni izbran
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.klub_pilot_vleke === this.klubPM && podatki.klub_letala === this.klubJ && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.klub_pilot_vleke === this.klubPM && podatki.klub_letala === this.klubJ && podatki.pilot === this.pilotName);
                }
              } else {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.klub_pilot_vleke === this.klubPM && podatki.klub_letala === this.klubJ && podatki.registracija === this.regLetala);
                } else {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.klub_pilot_vleke === this.klubPM && podatki.klub_letala === this.klubJ);
                }
              }
            }
          } else { //če ima izbran filter pilota jadralnega in filter pilota motornega
            if (this.klubM !== '') { //če je aktiven filter kluba motornega letala
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.klub_pilot_vleke === this.klubPM && podatki.klub_letala_vleke === this.klubM && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.klub_pilot_vleke === this.klubPM && podatki.klub_letala_vleke === this.klubM && podatki.pilot === this.pilotName);
                }
              } else {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.klub_pilot_vleke === this.klubPM && podatki.klub_letala_vleke === this.klubM && podatki.registracija === this.regLetala);
                } else {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.klub_pilot_vleke === this.klubPM && podatki.klub_letala_vleke === this.klubM);
                }
              }
            } else {
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.klub_pilot_vleke === this.klubPM && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.klub_pilot_vleke === this.klubPM && podatki.pilot === this.pilotName);
                }
              } else {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.klub_pilot_vleke === this.klubPM && podatki.registracija === this.regLetala);
                } else {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.klub_pilot_vleke === this.klubPM);
                }
              }
            }
          }
        } else { //če ima aktiven filter pilota jadralnega
          if (this.klubJ !== '') { //če je aktiven filtra kluba jadralnega
            if (this.klubM !== '') { //če je aktiven filter kluba motornega
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.klub_letala === this.klubJ && podatki.klub_letala_vleke === this.klubM && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.klub_letala === this.klubJ && podatki.klub_letala_vleke === this.klubM && podatki.pilot === this.pilotName);
                }
              } else {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.klub_letala === this.klubJ && podatki.klub_letala_vleke === this.klubM && podatki.registracija === this.regLetala);
                } else {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.klub_letala === this.klubJ && podatki.klub_letala_vleke === this.klubM);
                }
              }
            } else { //če ni aktiven filter kluba motornega
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.klub_letala === this.klubJ && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.klub_letala === this.klubJ && podatki.pilot === this.pilotName);
                }
              } else {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.klub_letala === this.klubJ && podatki.registracija === this.regLetala);
                } else {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.klub_letala === this.klubJ);
                }
              }
            }
          } else { //če ni aktiven filter kluba jadralnega
            if (this.klubM !== '') {
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.klub_letala_vleke === this.klubM && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.klub_letala_vleke === this.klubM && podatki.pilot === this.pilotName);
                }
              } else {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.klub_letala_vleke === this.klubM && podatki.registracija === this.regLetala);
                } else {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.klub_letala_vleke === this.klubM);
                }
              }
            } else {//če ni aktiven klub motornega
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.pilot === this.pilotName);
                }
              } else {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ && podatki.registracija === this.regLetala);
                } else {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubPJ);
                }
              }
            }
          }
        }
      } else {
        if (this.klubPM !== '') {
          if (this.klubJ !== '') {
            if (this.klubM !== '') {
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot_vleke === this.klubPM && podatki.klub_letala === this.klubJ && podatki.klub_letala_vleke === this.klubM && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot_vleke === this.klubPM && podatki.klub_letala === this.klubJ && podatki.klub_letala_vleke === this.klubM && podatki.pilot === this.pilotName);
                }
              } else {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot_vleke === this.klubPM && podatki.klub_letala === this.klubJ && podatki.klub_letala_vleke === this.klubM && podatki.registracija === this.regLetala);
                } else {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot_vleke === this.klubPM && podatki.klub_letala === this.klubJ && podatki.klub_letala_vleke === this.klubM);
                }
              }
            } else {
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot_vleke === this.klubPM && podatki.klub_letala === this.klubJ && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot_vleke === this.klubPM && podatki.klub_letala === this.klubJ && podatki.pilot === this.pilotName);
                }
              } else {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot_vleke === this.klubPM && podatki.klub_letala === this.klubJ && podatki.registracija === this.regLetala);
                } else {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot_vleke === this.klubPM && podatki.klub_letala === this.klubJ);
                }
              }
            }
          } else {
            if (this.klubM !== '') {
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot_vleke === this.klubPM && podatki.klub_letala_vleke === this.klubM && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot_vleke === this.klubPM && podatki.klub_letala_vleke === this.klubM && podatki.pilot === this.pilotName);
                }
              } else {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot_vleke === this.klubPM && podatki.klub_letala_vleke === this.klubM && podatki.registracija === this.regLetala);
                } else {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot_vleke === this.klubPM && podatki.klub_letala_vleke === this.klubM);
                }
              }
            } else {
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot_vleke === this.klubPM && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot_vleke === this.klubPM && podatki.pilot === this.pilotName);
                }
              } else {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot_vleke === this.klubPM && podatki.registracija === this.regLetala);
                } else {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot_vleke === this.klubPM);
                }
              }
            }
          }
        } else {
          if (this.klubJ !== '') {
            if (this.klubM !== '') {
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubJ && podatki.klub_letala_vleke === this.klubM && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubJ && podatki.klub_letala_vleke === this.klubM && podatki.pilot === this.pilotName);
                }
              } else {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubJ && podatki.klub_letala_vleke === this.klubM && podatki.registracija === this.regLetala);
                } else {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubJ && podatki.klub_letala_vleke === this.klubM);
                }
              }
            } else {
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubJ && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubJ && podatki.pilot === this.pilotName);
                }
              } else {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubJ && podatki.registracija === this.regLetala);
                } else {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubJ);
                }
              }
            }
          } else {
            if (this.klubM !== '') {
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala_vleke === this.klubM && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala_vleke === this.klubM && podatki.pilot === this.pilotName);
                }
              } else {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala_vleke === this.klubM && podatki.registracija === this.regLetala);
                } else {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala_vleke === this.klubM);
                }
              }
            } else {
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                }
                return this.PodatkiObracun.filter(podatki => podatki.pilot === this.pilotName);
              }
              if (this.regLetala !== '') {
                return this.PodatkiObracun.filter(podatki => podatki.registracija === this.regLetala);
              }
              return this.PodatkiObracun;
            }
          }
        }
      }
      if (this.pilotName !== '') {
        if (this.regLetala !== '') {
          return this.PodatkiObracun.filter(podatki => podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
        }
        return this.PodatkiObracun.filter(podatki => podatki.pilot === this.pilotName);
      }
      if (this.regLetala !== '') {
        return this.PodatkiObracun.filter(podatki => podatki.registracija === this.regLetala);
      }
      return this.PodatkiObracun;
    },
    FilterLetal() {
      if (this.prikaz === 'motorna') {
        return this.Letala.letala.filter(letalo => letalo.vrsta_letala === 'Motorno');
      } else {
        return this.Letala.letala.filter(letalo => letalo.vrsta_letala === 'Jadralno');
      }
    }
  },
  methods: {
    selectPilot(id) {
      let pilot = this.Piloti.piloti.find(p => p.id === id);
      if (pilot) {
        // this.pilotName = pilot.ime + ' ' + pilot.priimek;
        this.pilotName = pilot.sifra;
        this.dPilot = false;
      }
    },
    selectLetalo(id) {
      let letalo = this.Letala.letala.find(l => l.id === id);
      if (letalo) {
        this.regLetala = letalo.registracija;
        this.dLetalo = false; // Zapri dropdown po izbiri
      }
    },
    selectKlub(id) {
      let klub = this.Klubi.find(klub => klub.id === id);
      if (klub) {
        this.klub = klub.naziv;
        this.dKlubi = false;
      }
    },
    selectKlubPJ(id) {
      let klub = this.Klubi.find(klub => klub.id === id);
      if (klub) {
        this.klubPJ = klub.naziv;
        this.dKlubiPJ = false;
      }
    },
    selectKlubPM(id) {
      let klub = this.Klubi.find(klub => klub.id === id);
      if (klub) {
        this.klubPM = klub.naziv;
        this.dKlubiPM = false;
      }
    },
    selectKlubJ(id) {
      let klub = this.KlubiL.find(klub => klub.id === id);
      if (klub) {
        this.klubJ = klub.naziv;
        this.dKlubiJ = false;
      }
    },
    selectKlubM(id) {
      let klub = this.KlubiL.find(klub => klub.id === id);
      if (klub) {
        this.klubM = klub.naziv;
        this.dKlubiM = false;
      }
    },
    OpenPilot() {
      this.dPilot = !this.dPilot;
    },
    OpenLetalo() {
      this.dLetalo = !this.dLetalo;
    },
    OpenFiltri() {
      this.dFiltri = !this.dFiltri;
    },
    OpenKlub() {
      this.dKlubi = !this.dKlubi;
    },
    OpenKlubPJ() {
      this.dKlubiPJ = !this.dKlubiPJ;
    },
    OpenKlubPM() {
      this.dKlubiPM = !this.dKlubiPM;
    },
    OpenKlubJ() {
      this.dKlubiJ = !this.dKlubiJ;
    },
    OpenKlubM() {
      this.dKlubiM = !this.dKlubiM;
    },
    GetPodatkiObracuna() {
      let app = this;
      let podatki = new URLSearchParams();
      podatki.append("datumZ", this.datumO);
      podatki.append("datumK", this.datumD);
      axios
          .post("./api/log/jadralno/izpis/", podatki)
          .then(function (response) {
            app.PodatkiObracun = response.data.podatki;
            // app.CalculateFlights();
            app.AllFlightsTime = response.data.s_cas_letenja;
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
            } else {
              this.text = 'Napaka pri pridobivanju podatkov.';
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    GetLetala() {
      let app = this;
      axios
          .get("./api/sifranti/letala/izpis/")
          .then(function (response) {
            app.Letala = response.data;
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
            } else {
              this.text = 'Napaka pri pridobivanju podatkov.';
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    GetPiloti() {
      let app = this;
      axios
          .get("./api/sifranti/piloti/izpis/")
          .then(function (response) {
            app.Piloti.piloti = response.data.piloti.filter(pilot => pilot.datum_izbrisa == null);
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
            } else {
              this.text = 'Napaka pri pridobivanju podatkov.';
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    GetKlubi() {
      axios.get('./api/sifranti/klubi/izpis', {withCredentials: true}).then((response) => {
        this.Klubi = response.data.klubi;
        this.KlubiL = [...response.data.klubi];
        this.KlubiL.push({
          'id': 'lastno',
          'sifra': 'Privat-lastno',
          'naziv': 'Privat-lastno',
          'naslov': '/',
          'posta': '/',
          'kraj': '/',
          'tel': '/',
          'email': '/'
        });
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri pridobivanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    sestejCase() {
      let skupneMinute = 0;
      let skupneUre = 0;
      for (let i = 0; i < this.FiltriraniPodatki.length; i++) {
        // Pretvori oba časa v minute
        let [ure, minute] = this.FiltriraniPodatki[i].cas_letenja.split(':').map(Number);
        skupneMinute += minute;
        skupneUre += ure;
      }
      while (skupneMinute >= 60) {
        skupneMinute -= 60;
        skupneUre++;
      }
      // Formatiraj nazaj v HH:MM
      const ureStr = String(skupneUre).padStart(2, '0');
      const minuteStr = String(skupneMinute).padStart(2, '0');

      return `${ureStr}:${minuteStr}`;
    },
    sestejCaseVleke() {
      let skupneMinute = 0;
      let skupneUre = 0;
      for (let i = 0; i < this.FiltriraniPodatki.length; i++) {
        // Pretvori oba časa v minute
        let [ure, minute] = this.FiltriraniPodatki[i].cas_vleke.split(':').map(Number);
        skupneMinute += minute;
        skupneUre += ure;
      }
      while (skupneMinute >= 60) {
        skupneMinute -= 60;
        skupneUre++;
      }
      // Formatiraj nazaj v HH:MM
      const ureStr = String(skupneUre).padStart(2, '0');
      const minuteStr = String(skupneMinute).padStart(2, '0');

      return `${ureStr}:${minuteStr}`;
    },
    CalculateFlights() {
      let AllFlightsTime = '00:00';
      for (let i = 0; i < this.PodatkiObracun.length; i++) {
        this.AllFlightsTime = this.sestejCase(AllFlightsTime, this.PodatkiObracun[i].cas_letenja);
      }
    },
    OpenView(id) {
      this.izbranZapis = this.PodatkiObracun.filter(p => p.id === id);
      $(this.$refs.modalObracunMotZapisa).modal('show');
    },
    DetailsOff() {
      $(this.$refs.modalObracunMotZapisa).modal('hide');
    },
    PotrdiIzbris(id) {
      this.podatkiIzbris = {
        id: id
      };
      this.text = 'Ali res želite pobrisati zapis?';
      this.types = "Vprašanje";
      this.ShowNoti = true;
    },
    izbrisiZapis() {
      // BRISANJE
      let app = this;
      let izbris = new URLSearchParams();
      izbris.append("id_brisanja", this.podatkiIzbris.id);
      axios
          .post("./api/log/jadralno/brisi/", izbris)
          .then(function (response) {
            app.GetPodatkiObracuna();
            app.DetailsOff();
            app.podatkiIzbris = {};
            // alert(text);
            app.text = "Zapis uspešno pobrisan";
            app.types = "Uspešno";
            app.ShowNoti = true;
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = 'Napaka pri brisanju podatkov. ' + napaka.response.data.napaka;
            } else {
              this.text = 'Napaka pri brisanju podatkov.';
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    NatisniIzpise() {
      this.printing = true;
      let podatki = new URLSearchParams();
      podatki.append('zapisiJ', JSON.stringify(this.FiltriraniPodatki));
      podatki.append('datumO', this.datumO);
      podatki.append('datumD', this.datumD);
      axios.post('./api/log/pdf/', podatki, {withCredentials: true}).then((response) => {
        window.open(this.pot + response.data.datoteka);
        this.printing = false;
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri pridobivanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
        this.printing = false;
      });
    },
    IzvozCSV() {
      this.exporting = true;
      let podatki = new URLSearchParams();
      podatki.append('zapisiJ', JSON.stringify(this.FiltriraniPodatki));
      podatki.append('datumO', this.datumO);
      podatki.append('datumD', this.datumD);
      axios.post('./api/log/csv/', podatki, {withCredentials: true}).then((response) => {
        window.open(this.pot + response.data.datoteka);
        this.exporting = false;
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri pridobivanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
        this.exporting = false;
      });
    },
    SendToMail() {
      this.sending = true;
      let podatki = new URLSearchParams();
      podatki.append('zapisiJ', JSON.stringify(this.FiltriraniPodatki));
      podatki.append('datumO', this.datumO);
      podatki.append('datumD', this.datumD);
      axios.post('./api/log/pdf/', podatki, {withCredentials: true}).then((response) => {
        let podatkiMail = new URLSearchParams();
        podatkiMail.append('datoteka', response.data.datoteka);
        podatkiMail.append('zadeva', 'Izpisek jadralnih letov');
        axios.post('./api/log/mail/', podatkiMail, {withCredentials: true}).then((response) => {
          // alert(response.data.sporocilo);
          this.text = (response.data.sporocilo);
          this.types = "Uspešno";
          this.ShowNoti = true;
          this.sending = false;
        }).catch((error) => {
          // console.log(error.response.data.sporocilo);
          this.text = (error.response.data.sporocilo);
          this.types = "Napaka";
          this.ShowNoti = true;
          this.sending = false;
        });
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri pridobivanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
        this.sending = false;
      });
    },
    InvoiceDetails() {
      $(this.$refs.modalObracunCena).modal('show');
    },
    InvoiceDetailsOff() {
      $(this.$refs.modalObracunCena).modal('hide');
    },
    ObracunajLet() {
      if (this.klubPJ !== '' && this.klubJ !== '' && this.klubM !== '') {
        let podatki = new URLSearchParams();
        podatki.append('reg_j', this.regLetala);
        // podatki.append('reg_v', ); //za enkrat ni tega podatka
        podatki.append('klub_pilota_j', this.klubPJ);
        podatki.append('klub_pilota_v', this.klubPM);
        podatki.append('klub_letala_j', this.klubJ);
        podatki.append('klub_letala_v', this.klubM);
        podatki.append('cas_letenja', this.sestejCase());
        podatki.append('cas_vleke', this.sestejCaseVleke());
        podatki.append('st_letov', this.FiltriraniPodatki.length);
        axios.post('./api/obracuni/jadralno/', podatki, {withCredentials: true}).then((response) => {
          this.izracun = response.data.izracun;
          this.InvoiceDetails();
        }).catch((napaka) => {
          if (napaka.response.status === 401) {
            this.$router.push('/Logout');
          }
          if (napaka.response.data.napaka !== undefined) {
            this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
          } else {
            this.text = 'Napaka pri pridobivanju podatkov.';
          }
          this.types = 'Napaka';
          this.ShowNoti = true;
        });
      } else {
        // alert('Za obračun leta je potrebno izbrati registracijo letala in klub pilota!');
        app.text = ('Za obračun leta je potrebno izbrati registracijo letala in klub pilota!');
        app.types = "Napaka";
        app.ShowNoti = true;
      }
    },
    ToogleSort() {
      this.sortAscending = !this.sortAscending;
      this.PodatkiObracun.reverse();
    },
    IzbranaPolja() {
      while (this.polja.length > 5) {
        this.polja.pop();
        this.text = ('Izberete lahko največ 5 polj hkrati!');
        this.types = "Napaka";
        this.ShowNoti = true;
      }
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    changeLang(lang) {
      i18n.global.locale.value = lang
    },
  }
}
</script>
<template>
  <div class="container p-2" v-if="prevodi">
    <Transition name="fade">
      <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @da="izbrisiZapis" @ne="ShowNoti = false" @closeNotification="ShowNoti = false" />
    </Transition>
    <div class="col-12">
      <div class="container">
        <div class="label-date p-2 col-6" >{{$t('labels.datumOd')}}</div>
        <input class="input border-0 rounded-4 p-2 fs-5" type="date" id="datum" v-model="datumO" required @change="GetPodatkiObracuna"/>
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <div class="label-date p-2 col-6" >{{$t('labels.datumDo')}}</div>
        <input class="input border-0 rounded-4 p-2 fs-5" type="date" id="datum" v-model="datumD" required @change="GetPodatkiObracuna" />
      </div>
    </div>
    <div class="hr-with-text">{{$t('main.title')}}</div>
    <!-- KLUB PILOTA JADRALNEGA LETALA -->
    <div class="col-12">
      <div class="container">
        <label class="label-dropdown" for="regLetala">{{$t('labels.klubPJ')}} <button v-if="klubPJ !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="klubPJ = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
        <div class="drop-down-icon text-black" @click.prevent="OpenKlubPJ()">
          <i v-show="!dKlubiPJ" class="fas fa-chevron-right"></i>
          <i v-show="dKlubiPJ" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5" id="regLetala" @click.prevent="OpenKlubPJ">{{klubPJ}}</button>
        <transition name="fade">
          <drop-down @klub="selectKlubPJ" :data="Klubi" type="klubi" class="drop-down-btn" v-if="dKlubiPJ" />
        </transition>
      </div>
    </div>
    <!-- KLUB PILOTA MOTORNEGA LETALA -->
    <div class="col-12">
      <div class="container">
        <label class="label-dropdown" for="regLetala">{{$t('labels.klubPM')}} <button v-if="klubPM !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="klubPM = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
        <div class="drop-down-icon text-black" @click.prevent="OpenKlubPM()">
          <i v-show="!dKlubiPM" class="fas fa-chevron-right"></i>
          <i v-show="dKlubiPM" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5" id="regLetala" @click.prevent="OpenKlubPM">{{klubPM}}</button>
        <transition name="fade">
          <drop-down @klub="selectKlubPM" :data="Klubi" type="klubi" class="drop-down-btn" v-if="dKlubiPM" />
        </transition>
      </div>
    </div>
    <!-- KLUB JADRALNEGA LETALA -->
    <div class="col-12">
      <div class="container">
        <label class="label-dropdown" for="regLetala">{{$t('labels.klubJ')}} <button v-if="klubJ !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="klubJ = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
        <div class="drop-down-icon text-black" @click.prevent="OpenKlubJ()">
          <i v-show="!dKlubiJ" class="fas fa-chevron-right"></i>
          <i v-show="dKlubiJ" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5" id="regLetala" @click.prevent="OpenKlubJ">{{klubJ}}</button>
        <transition name="fade">
          <drop-down @klub="selectKlubJ" :data="KlubiL" type="klubi" class="drop-down-btn" v-if="dKlubiJ" />
        </transition>
      </div>
    </div>
    <!-- KLUB MOTORNEGA LETALA -->
    <div class="col-12">
      <div class="container">
        <label class="label-dropdown" for="regLetala">{{$t('labels.klubM')}} <button v-if="klubM !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="klubM = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
        <div class="drop-down-icon text-black" @click.prevent="OpenKlubM()">
          <i v-show="!dKlubiM" class="fas fa-chevron-right"></i>
          <i v-show="dKlubiM" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5" id="regLetala" @click.prevent="OpenKlubM">{{klubM}}</button>
        <transition name="fade">
          <drop-down @klub="selectKlubM" :data="KlubiL" type="klubi" class="drop-down-btn" v-if="dKlubiM" />
        </transition>
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label class="label-dropdown" for="pilotName">{{$t('labels.pilot')}} <button v-if="pilotName !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="pilotName = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
        <div class="drop-down-icon text-black" @click.prevent="OpenPilot()">
          <i v-show="!dPilot" class="fas fa-chevron-right"></i>
          <i v-show="dPilot" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5" id="pilotName" @click.prevent="OpenPilot">{{pilotName}}</button>
        <transition name="fade">
          <drop-down @pilot="selectPilot" :data="Piloti" type="piloti" class="drop-down-btn" v-if="dPilot" />
        </transition>
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label class="label-dropdown" for="regLetala">{{$t('labels.reg')}} <button v-if="regLetala !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="regLetala = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
        <div class="drop-down-icon text-black" @click.prevent="OpenLetalo()">
          <i v-show="!dLetalo" class="fas fa-chevron-right"></i>
          <i v-show="dLetalo" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5" id="regLetala" @click.prevent="OpenLetalo">{{regLetala}}</button>
        <transition name="fade">
          <drop-down @letalo="selectLetalo" :data="FilterLetal" type="letalo" class="drop-down-btn" v-if="dLetalo" />
        </transition>
      </div>
    </div>
    <!-- <div class="col-12">
        <div class="container">
            <label class="label-dropdown" for="chooseFilter">Dodatni filtri :</label>
            <div class="drop-down-icon text-black" @click.prevent="OpenFiltri">
                <i v-show="!dFiltri" class="fas fa-chevron-right"></i>
                <i v-show="dFiltri" class="fas fa-chevron-down"></i>
            </div>
            <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="regLetala" @click.prevent="OpenFiltri"></button>
            <transition name="fade">
                <filtri-o class="drop-down-btn" v-if="dFiltri"/>
            </transition>
        </div>
    </div> -->
    <div class="col-12 p-2">
      <div class="">
        <h4 class="text-white">Podatki <br/>
          <div class='row'>
            <div class='col-5'>
              <button class='btn btn-sm btn-outline-warning' :disabled="!FiltriraniPodatki.length > 0 || this.exporting" @click.prevent="IzvozCSV" data-umami-event="Obracun-Jadralna-izpis-csv">{{$t('buttons.csv')}} <i class="fas fa-file-csv" :class="{'fa-spin': this.exporting}"></i></button>
            </div>
            <div class='col-4'>
              <button class='btn btn-sm btn-outline-warning' :disabled="!FiltriraniPodatki.length > 0 || this.printing" @click.prevent="NatisniIzpise" data-umami-event="Obracun-Jadralna-izpis-tisk">{{$t('buttons.natisni')}} <i class="fas fa-print" :class="{'fa-spin': this.printing}"></i></button>
            </div>
            <div class='col-3'>
              <button class='btn btn-sm btn-outline-warning' :disabled="!FiltriraniPodatki.length > 0 || this.sending" @click.prevent="SendToMail" data-umami-event="Obracun-Jadralna-izpis-email">{{$t('buttons.poslji')}} <i class="far fa-envelope" :class="{'fa-spin': this.sending}"></i></button>
            </div>
            <br/>
            <div class='col-1 mt-2'>
              <button class='btn btn-sm btn-outline-warning' :disabled="!FiltriraniPodatki.length > 0" @click.prevent="odpriPolja = !odpriPolja"><i class="fas fa-sort"></i></button>
            </div>
            <div class='col-1 mt-2'>
              <button class="btn btn-sm btn-outline-secondary" @click.prevent="ToogleSort()"><i v-if="sortAscending" class="fas fa-chevron-down"></i> <i v-if="!sortAscending" class="fas fa-chevron-up"></i></button>
            </div>
            <div class='col-12'>
              <select v-show="odpriPolja" class="form-select p-2 mt-2" v-model="polja" multiple @change="IzbranaPolja">
                <option value='REG'>{{$t('table.reg')}}</option>
                <option value='VZLET'>{{$t('table.vzlet')}}</option>
                <option value='PILOT'>{{$t('table.pilot')}}</option>
                <option value='TRAJANJE'>{{$t('table.trajanje')}}</option>
                <option value='NALOGA'>{{$t('table.naloga')}}</option>
                <option value='DATUM'>{{$t('table.datum')}}</option>
                <option value='PRISTANEK'>{{$t('table.pristanek')}}</option>
              </select>
            </div>
          </div>
        </h4>
      </div>
      <!-- IZPIS LETOV -->
      <section class="flight-section-pregled mt-2">

        <div class="section-header">
          <div class="section-icon motor">
            <i class="fas fa-paper-plane"></i>
          </div>
          <div class="d-flex col-10 justify-content-between">
            <div>
              <h2>{{ $t('table.titleJ') }}</h2>
              <span>{{ FiltriraniPodatki.length }} zapisov</span>
            </div>
            <div >
              <h2 class="text-success"> {{ $t('data.title').toUpperCase() }}</h2>
              <span>{{$t('labels.casV')}} {{this.sestejCaseVleke()}}</span>
            </div>
            <div>
              <h2>{{ $t('labels.casVZ') }}</h2>
              <span> {{ this.sestejCase() }} </span>
            </div>
          </div>
        </div>

        <div class="flight-list">

          <div
              class="flight-item-pregled"
              v-for="(id, index) in FiltriraniPodatki"
              @click.prevent="OpenView(id.id)"
          >
            <div class="flight-task">
              <span class="label-flight">{{$t('table.datum')}}</span>
              <strong>{{ id.datum.substring(0,5) }}</strong>
            </div>

            <div class="flight-date" v-if="polja.includes('REG')">
              <i class="fas fa-paper-plane"></i>
              <span>{{ id.registracija }}</span>
            </div>

            <div class="flight-user" v-if="polja.includes('VZLET')">
              <span class="label-flight">{{$t('table.vzlet')}} <i class="fas" :class="{'fa-sort-up' : sortAscending, 'fa-sort-down' : !sortAscending}"></i></span>
              <strong>{{ id.cas_vzleta }}</strong>
            </div>

            <div class="flight-task" v-if="polja.includes('PILOT')">
              <span class="label-flight">{{$t('table.pilot')}}</span>
              <strong>{{ id.pilot }}</strong>
            </div>

            <div class="flight-task" v-if="polja.includes('TRAJANJE')">
              <span class="label-flight">{{$t('table.trajanje')}}</span>
              <strong>{{ id.cas_letenja }}</strong>
            </div>

            <div class="flight-task" v-if="polja.includes('NALOGA')">
              <span class="label-flight">{{$t('table.naloga')}}</span>
              <strong>{{ id.naloga }}</strong>
            </div>

            <div class="flight-task" v-if="polja.includes('DATUM')">
              <span class="label-flight">{{$t('table.datum')}}</span>
              <strong>{{ id.datum.substr(0,5) }}</strong>
            </div>

            <div class="flight-task" v-if="polja.includes('PRISTANEK')">
              <span class="label-flight">{{$t('table.pristanek')}}</span>
              <strong>{{ id.cas_pristanka }}</strong>
            </div>

            <div class="flight-action">
              <i class="fas fa-chevron-right"></i>
            </div>

          </div>

          <div v-if="!FiltriraniPodatki.length" class="empty-state">
            <i class="far fa-folder-open"></i>
            <span>Ni podatkov</span>
          </div>

        </div>

      </section>
      <!-- OBRAČUN LETA -->
      <!--                 <div class="col-12 p-2 d-flex justify-content-center">
                          <button class='btn btn-sm btn-outline-success' @click.prevent="ObracunajLet()"><i class="fas fa-calculator"></i> Obračunaj izpisane lete <i class="fas fa-receipt"></i></button>
                      </div> -->
    </div>
    <!-- ODMIK OD CAPTCHE -->
    <div class='col-12 p-5'></div>
    <div class='col-12 p-2'></div>
    <!-- OBRAČUN PODROBNO -->
    <div class="modal modal-kartica" ref="modalObracunMotZapisa" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content list-dark border-orange" v-if="izbranZapis.length > 0">
          <div class='d-flex justify-content-end'>
            <button class="modern-close-btn mt-2 me-2" @click.prevent="DetailsOff">
              <span aria-hidden="true"><i class="fas fa-2x fa-times"></i></span>
            </button>
          </div>
          <div class='modal-header'>
            <h5 class="card-title"><i class="fas fa-plane"></i> {{$t('modal.izbran')}}</h5>
          </div>
          <div class="modal-body col-12" style="overflow-y: scroll;">
            <ul class='list-group list-group-flush'>
              <li class='list-group-item list-dark'>{{$t('modal.reg')}} {{izbranZapis[0].registracija}}</li>
              <!-- <li class='list-group-item list-dark'>vlecno: <i class="fas" :class="{'fa-times': !izbranZapis[0].vlecno, 'fa-check': izbranZapis[0].vlecno }"></i></li> -->
              <li class='list-group-item list-dark'>{{$t('modal.pilot')}} {{izbranZapis[0].pilot}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.regV')}} {{izbranZapis[0].reg_vleke}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.instruktor')}} {{izbranZapis[0].instruktor}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.namen')}} {{izbranZapis[0].namen}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.naloga')}} {{izbranZapis[0].naloga}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.casV')}} {{izbranZapis[0].cas_vzleta}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.casO')}} {{izbranZapis[0].cas_odklopa}}</li>
              <!-- <li class='list-group-item list-dark'>cas vziga: {{izbranZapis[0].cas_vziga}}</li> -->
              <!-- <li class='list-group-item list-dark'>cas vzleta: {{izbranZapis[0].cas_vzleta}}</li> -->
              <li class='list-group-item list-dark'>{{$t('modal.casP')}} {{izbranZapis[0].cas_pristanka}}</li>
              <!-- <li class='list-group-item list-dark'>cas ugasanja: {{izbranZapis[0].cas_ugasanja}}</li> -->
              <li class='list-group-item list-dark'>{{$t('modal.casL')}} {{izbranZapis[0].cas_letenja}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.casVL')}} {{izbranZapis[0].cas_vleke}}</li>
              <!-- <li class='list-group-item list-dark'>kilometri: {{izbranZapis[0].kilometri}}</li> -->
              <!-- <li class='list-group-item list-dark'>nocno: {{izbranZapis[0].nocno}}</li> -->
              <!-- <li class='list-group-item list-dark'>vizuelno: {{izbranZapis[0].vizuelno}}</li> -->
              <li class='list-group-item list-dark'>{{$t('modal.opomba')}} {{izbranZapis[0].tip}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.datumL')}} {{izbranZapis[0].datum}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.datumV')}} {{izbranZapis[0].datum_vnosa}}</li>
            </ul>
          </div>
          <div class="modal-footer col-12"><button class="btn btn-outline-danger" @click.prevent="PotrdiIzbris(izbranZapis[0].id)">{{$t('buttons.brisiZapis')}}</button></div>
        </div>
      </div>
    </div>
    <!-- OBRAČUN CENE IZPIS -->
    <div class="modal modal-kartica" ref="modalObracunCena" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content list-dark border-orange">
          <div class='d-flex justify-content-end'>
            <button class="modern-close-btn mt-2 me-2" @click.prevent="InvoiceDetailsOff">
              <span aria-hidden="true"><i class="fas fa-2x fa-times"></i></span>
            </button>
          </div>
          <div class='modal-header'>
            <h5 class="card-title"><i class="fas fa-plane"></i> Račun za {{this.regLetala}}</h5>
          </div>
          <div class="modal-body col-12" style="overflow-y: scroll;">
            <ul class='list-group list-group-flush'>
              <li class='list-group-item list-dark'>registracija: {{this.regLetala}}</li>
              <li class='list-group-item list-dark'>št. letov: {{this.izracun.st_pristankov}}</li>
              <li class='list-group-item list-dark' v-if="this.izracun.cena_pristanka !== null">cena pristanka: {{this.izracun.cena_pristanka}}€</li>
              <li class='list-group-item list-dark' v-if="this.izracun.cena_najema !== null">cena najema: {{this.izracun.cena_najema}}€</li>
              <li class='list-group-item list-dark' v-if="this.izracun.cena_vleke !== null">cena vleke: {{this.izracun.cena_vleke}}€ / min</li>
              <li class='list-group-item list-dark'>skupni čas letenja: {{this.sestejCase()}}</li>
              <li class='list-group-item list-dark'>skupni čas letenja v minutah: {{this.izracun.cas_letenja_minute}}</li>
              <li class='list-group-item list-dark' v-if="this.izracun.cas_vleke_minute !== null">skupni čas vleke: {{this.sestejCaseVleke()}}</li>
              <li class='list-group-item list-dark' v-if="this.izracun.cas_vleke_minute !== null">skupni čas vleke v minutah: {{this.izracun.cas_vleke_minute}}</li>
              <li class='list-group-item border-lorange'>Znesek za plačilo: {{this.izracun.izracun}}€</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>